export const koform = {
  id: "koform",
  disciplines: "Poster, Print",
  year: 2025,
  project: "Ko/form Exhibition",
  initiatedAt: "Self-Initiated work",
  shortInitiatedAt: "Self-initiated",
  thumbnailUrl: "/assets/Koform/00-1x1.webp",
  description:
    "Ko/form is a self-initiated poster series for a fictional exhibition exploring proximity and distance. Overlapping color fields shift across the layouts, visually translating social states of approach, collision, and separation.",
  credits: ["Self-Initiated work"],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Koform/01-K-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Koform/02-K-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Koform/03-K-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Koform/04-K-16x9-2560-heller.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
